<!--
  Generated template for the NotificationDetailsPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content>
	<span class="notification-hero" [style.background-image]="'url('+news.imgLink+')'">
	</span>
	<ion-item *ngIf="news.event" class="notification-event" no-lines (click)="openEvent()">
		<span text-primary block>{{news.event.name}}</span>
		<span class="small">{{news.event.startDate}}</span>
		<ion-icon name="arrow-forward" item-end></ion-icon>
	</ion-item>
	<div class="padding">
		<h3>{{news.title}}</h3>
		<span class="small">{{news.formattedDate}}</span>

		<p class="notification-content" [innerHTML]="news.htmlContent">
		</p>
	</div>
</ion-content>
